import { VITE_ALEO_BASE_URL, VITE_NETWORK_TYPE } from '@/configs/env';
import { fetchClient } from '@/lib/fetchClient';
import { useCallback } from 'react';
import { useAleoWallet } from './useAleoWallet';

export type RecordInterface = {
  blockHeight: number;
  blockTimestamp: number;
  commitment: string;
  functionName: string;
  outputIndex: number;
  owner: string;
  programName: string;
  recordCiphertext: string;
  recordPlaintext?: string;
  plaintext?: string;
  recordName: string;
  sender: string;
  spent: boolean;
  tag: string;
  transactionId: string;
  transitionId: string;
  transactionIndex: number;
  transitionIndex: number;
  data?: {
    [key: string]: string;
  };
};

export const useProgram = () => {
  const { requestRecords } = useAleoWallet();

  const mapping = useCallback((program: string, mapping: string) => {
    return {
      get: async (mKey: any) => {
        const { data } = await fetchClient.get<string>(`${VITE_ALEO_BASE_URL}/${VITE_NETWORK_TYPE}/program/${program}/mapping/${mapping}/${mKey}`);
        return data;
      }
    };
  }, []);

  const program = useCallback(
    (program: string) => {
      return {
        map: (mName: string) => mapping(program, mName)
      };
    },
    [mapping]
  );

  const getProgramRecords = async (programName: string, unspent: boolean = true): Promise<RecordInterface[]> => {
    if (!requestRecords) {
      return [];
    }
    const records = (await requestRecords!(programName, true)) as RecordInterface[];

    if (unspent) {
      return records.filter((rec) => !rec.spent);
    }
    return records;
  };

  return {
    program,
    mapping,
    getProgramRecords
  };
};
